var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54F3A"
    },
    d: "M510.27,171.231L463.861,16.535C460.916,6.722,451.882,0,441.635,0H256H70.366 C60.119,0,51.084,6.722,48.14,16.535L1.732,171.231c-0.65,2.163-0.979,4.409-0.979,6.669c0,35.517,18.528,66.77,46.409,84.663 v226.233c0,12.817,10.389,23.204,23.204,23.204h123.756H256h61.878h123.756c12.815,0,23.204-10.388,23.204-23.204V262.563 c27.881-17.892,46.409-49.147,46.409-84.663C511.247,175.64,510.918,173.395,510.27,171.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73281D"
    },
    d: "M510.27,171.231L463.861,16.535C460.916,6.722,451.882,0,441.635,0H256H70.366 C60.119,0,51.084,6.722,48.14,16.535L1.732,171.231c-0.65,2.163-0.979,4.409-0.979,6.669c0,35.517,18.528,66.77,46.409,84.663 c7.17,4.602,14.951,8.321,23.204,10.997c7.399,2.399,15.173,3.949,23.204,4.562c2.556,0.196,5.128,0.329,7.735,0.329 c23.63,0,45.371-8.213,62.554-21.906c5.408-4.31,10.375-9.147,14.794-14.464c4.418,5.317,9.385,10.153,14.794,14.464 c17.184,13.694,38.924,21.906,62.554,21.906s45.371-8.213,62.553-21.906c5.408-4.31,10.375-9.147,14.795-14.464 c4.418,5.317,9.385,10.153,14.794,14.464c17.184,13.694,38.924,21.906,62.554,21.906c2.607,0,5.179-0.133,7.735-0.329 c8.032-0.613,15.805-2.163,23.204-4.562c8.253-2.676,16.034-6.397,23.204-10.997c27.881-17.892,46.409-49.147,46.409-84.663 C511.247,175.64,510.918,173.395,510.27,171.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54F3A"
    },
    d: "M170.918,488.796v-23.204V348.023c0-12.813,10.389-23.204,23.204-23.204H256v-46.367 c-23.63,0-45.371-8.213-62.554-21.906c-5.408-4.31-10.375-9.147-14.794-14.464c-4.418,5.317-9.385,10.154-14.795,14.464 c-17.182,13.694-38.921,21.906-62.553,21.906c-2.607,0-5.179-0.133-7.735-0.329c-8.032-0.613-15.805-2.163-23.204-4.562 c-8.253-2.676-16.034-6.397-23.204-10.997v226.233c0,12.817,10.389,23.204,23.204,23.204h123.756 C181.307,512,170.918,501.612,170.918,488.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54F3A"
    },
    d: "M194.122,324.819c-12.815,0-23.204,10.391-23.204,23.204v117.569v23.204 c0,12.817,10.389,23.204,23.204,23.204H256V324.819H194.122L194.122,324.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54F3A"
    },
    d: "M341.082,488.796v-23.204V348.023c0-12.813-10.389-23.204-23.204-23.204H256V512h61.878 C330.695,512,341.082,501.612,341.082,488.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73281D"
    },
    d: "M93.57,278.122c2.556,0.196,5.128,0.329,7.735,0.329c23.63,0,45.371-8.213,62.553-21.906 c5.408-4.31,10.375-9.147,14.795-14.464c4.418,5.317,9.385,10.154,14.794,14.464c17.184,13.694,38.924,21.906,62.554,21.906V0 H70.366C60.119,0,51.084,6.722,48.14,16.535L1.732,171.231c-0.65,2.163-0.979,4.409-0.979,6.669 c0,35.517,18.528,66.77,46.409,84.663c7.17,4.602,14.951,8.321,23.204,10.997C77.766,275.96,85.538,277.51,93.57,278.122z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreRejected);
export default __webpack_public_path__ + "static/media/storeRejected.1dcc26b227f56bda878cc8f5a87cd60e.svg";
export { ForwardRef as ReactComponent };